import { disableGa4, enableGa4 } from './ga4';

export type PageView = {
    /** The page's name in GA's reports, e.g. "Case study: Selling solar the easy way". */
    title: string;
    url: string;
};

let consented = false;
/** The latest page view seen before consent, so accepting doesn't lose the page the visitor is on. */
let pendingPage: PageView | undefined;

/**
 * GA's automatic page views are off: `send_page_view: false` in ./ga4.ts, and "page changes based on browser
 * history events" unticked in the GA admin. On a client-side route change they fire before the new page has
 * rendered, so they'd record the previous page's title. Each page sends its own instead, via PageViewTracker.
 */
const pageView = (page: PageView) => {
    if (!consented) {
        pendingPage = page;
        return;
    }

    window.gtag?.('event', 'page_view', { page_title: page.title, page_location: page.url });
};

/** A click on one of the links worth counting: LinkedIn, the CV page, the CV download. */
const trackLink = (href: string, name: string) => {
    if (!consented) return;

    window.gtag?.('event', 'link_click', { link_url: href, link_name: name });
};

/**
 * Driven by the cookie consent choice. Until it is granted Google Analytics isn't loaded and nothing is sent.
 * Withdrawing it stops sending and clears GA's cookies.
 */
const setConsent = (granted: boolean) => {
    consented = granted;

    if (!granted) {
        pendingPage = undefined;
        disableGa4();
        return;
    }

    enableGa4();

    if (pendingPage) {
        const page = pendingPage;
        pendingPage = undefined;
        pageView(page);
    }
};

export default {
    setConsent,
    pageView,
    trackLink,
};
